import React, {useEffect, useMemo, useState} from 'react';
import { Badge } from '@mantine/core';
import dayjs from "dayjs";

const getDaysRemainingTagColor = (value) => {
    if (value >= 10) return 'rgb(82, 196, 26)';
    if (value < 10 && value >= 5) return '#FFEC19';
    if (value < 5 && value > 0) return '#FFC100';
    if (value === 0) return '#F6412D';
    if (value < 0) return '';
}

const DaysRemaining = ({ bidDate, square }: { bidDate: any, square: boolean }) => {
    const [daysRemaining, setDaysRemaining] = useState<number>(0);
    const [daysRemainingColor, setDaysRemainingColor] = useState<string>('');

    const calculateRemainingDays = (bidDate: any) => {
        if (bidDate) {
            const currentDate = dayjs();
            const endDate = dayjs(bidDate);
            const remainingDays = Math.ceil(endDate.diff(currentDate, 'day', true));
            return remainingDays;
        }
        return 0;
    };

    const tagValue = useMemo(() => {
        let val = ''
        if (daysRemaining < 0) val = 'Past Bid Date';
        if (bidDate && daysRemaining >= 0) val = `${daysRemaining} Days Remaining`;
        return val;
    },[daysRemaining, bidDate])

    useEffect(() => {
        const days = calculateRemainingDays(bidDate);
        const color = getDaysRemainingTagColor(days);
        setDaysRemaining(days);
        //@ts-ignore
        setDaysRemainingColor(color);
    },[bidDate])

    return (
        <Badge color={daysRemainingColor as any} radius={square ? 'xs' : 'xl'} style={{ display: tagValue ? '' : 'none' }}>
            {tagValue}
        </Badge>
    );
};

export default DaysRemaining;
